import { faCopy } from "@fortawesome/free-regular-svg-icons/faCopy";
export let iconCopy = faCopy;
export function overwriteCopy(icon) {
    iconCopy = icon;
}
export default iconCopy;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29weS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9jb3B5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSw0Q0FBNEMsQ0FBQztBQUVwRSxNQUFNLENBQUMsSUFBSSxRQUFRLEdBQUcsTUFBTSxDQUFDO0FBRTdCLE1BQU0sVUFBVSxhQUFhLENBQUMsSUFBb0I7SUFDaEQsUUFBUSxHQUFHLElBQUksQ0FBQztBQUNsQixDQUFDO0FBRUQsZUFBZSxRQUFRLENBQUMifQ==